import React from 'react';
import { getScopedProviderOptions } from 'api/group';
import { TScopedProviderOption } from 'types/group';

let globalData: TScopedProviderOption[] = [];

// Providers already in the practice on Klarity that a team owner can pick to credential.
const useScopedProviderOptions = (): [TScopedProviderOption[], boolean, () => void] => {
    const [loading, setLoading] = React.useState(true);
    const [data, setData] = React.useState<TScopedProviderOption[]>(globalData);

    const fetchData = React.useCallback(async () => {
        setLoading(true);
        try {
            const result = await getScopedProviderOptions({ includeSelf: false });
            if (!result.error) {
                const list: TScopedProviderOption[] = result?.data?.data || [];
                globalData = list;
                setData(list);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, []);

    React.useEffect(() => {
        fetchData();
    }, [fetchData]);

    return [data, loading, fetchData];
};

export default useScopedProviderOptions;
